var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponentsNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35628 0.92688C7.77256 0.77714 8.22777 0.77714 8.64704 0.92688L14.397 2.98131C15.1577 3.25383 15.6668 3.97558 15.6668 4.78717V12.0585C15.6668 12.8671 15.1577 13.5919 14.394 13.8644L8.64404 15.9188C8.22777 16.0685 7.77256 16.0685 7.35329 15.9188L1.60329 13.8644C0.842611 13.5919 0.333496 12.8701 0.333496 12.0585V4.78717C0.333496 3.97857 0.842611 3.25383 1.60628 2.98131L7.35628 0.92688ZM8.00016 2.73274L2.79821 4.58951L8.00016 6.44628L13.2021 4.58951L8.00016 2.73274ZM8.9585 13.7715L13.7502 12.0615V6.43131L8.9585 8.14133V13.7715Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentsNavigation);
export default __webpack_public_path__ + "static/media/components-navigation.821b8a234b61b7a0dc4e73a8d1b852d5.svg";
export { ForwardRef as ReactComponent };